// Tokens of the Votebox questions design (accessible selection mockup, #23284).
// Contrast on white: text 14.66:1, secondary text 6.28:1, accent 5.70:1, success 5.13:1.
// The success green is also the "Pour" option and the selected candidate color.
export const VOTEBOX_TEXT_COLOR = "#1f2a30";
export const VOTEBOX_WHITE = "#ffffff";
export const VOTEBOX_SECONDARY_TEXT_COLOR = "#55626b";
export const VOTEBOX_ACCENT_COLOR = "#4f6a7c";
export const VOTEBOX_SUCCESS_COLOR = "#2E7D32";
// "Contre" option, 5.62:1 on white.
export const VOTEBOX_AGAINST_COLOR = "#C62828";
// Abstention and the options after it, switched off switch: 5.47:1 on white.
export const VOTEBOX_NEUTRAL_OPTION_COLOR = "#5F6B73";
export const VOTEBOX_SUCCESS_BACKGROUND_COLOR = "#eef6ef";
export const VOTEBOX_MUTED_BACKGROUND_COLOR = "#f3f5f7";
// Hover of an uncolored option (election candidate).
export const VOTEBOX_HOVER_BACKGROUND_COLOR = "#f0f0f0";
// Borders without meaning of their own (unselected candidate, voter card).
export const VOTEBOX_NEUTRAL_BORDER_COLOR = "#c4ccd2";
// Empty selection box of a candidate: 3.09:1, above the 3:1 required for a graphic (RGAA 3.3).
export const VOTEBOX_BOX_BORDER_COLOR = "#8a949b";
export const VOTEBOX_DISABLED_BORDER_COLOR = "#d5dadd";
export const VOTEBOX_DISABLED_TEXT_COLOR = "#6b757c";
export const VOTEBOX_DISABLED_INPUT_BACKGROUND_COLOR = "#eef0f2";
// Selection box of a selected candidate, over the selection color.
export const VOTEBOX_SELECTED_BOX_BACKGROUND_COLOR = "rgb(255 255 255 / 22%)";

export const VOTEBOX_BORDER_WIDTH = "2px";
export const VOTEBOX_OPTION_RADIUS = "8px";
export const VOTEBOX_CARD_RADIUS = "10px";
export const VOTEBOX_INPUT_RADIUS = "6px";
export const VOTEBOX_OPTION_MIN_HEIGHT = "48px";
export const VOTEBOX_VOTER_CARD_MIN_HEIGHT = "60px";
// Minimum target size kept for text buttons (WCAG 2.5.8 asks for 24px).
export const VOTEBOX_TEXT_BUTTON_MIN_HEIGHT = "44px";
// Text buttons between two blocks (show or hide proxies): the 24px minimum, so the spacing stays as before.
export const VOTEBOX_COMPACT_TEXT_BUTTON_MIN_HEIGHT = "24px";
export const VOTEBOX_PILL_BUTTON_HEIGHT = "36px";
export const VOTEBOX_SWITCH_WIDTH = "46px";
export const VOTEBOX_SWITCH_HEIGHT = "28px";
export const VOTEBOX_SWITCH_KNOB_SIZE = "20px";
export const VOTEBOX_SWITCH_KNOB_OFFSET = "4px";
// Between the elements of a row: a box and its text, a label and its switch.
export const VOTEBOX_ROW_GAP = "12px";
// Inside a muted panel, such as the proxies switch.
export const VOTEBOX_PANEL_PADDING = "12px 14px";
// Under the validate button, so that it does not touch the footer.
export const VOTEBOX_ACTION_SECTION_MARGIN_BOTTOM = "1rem";

// Descriptions, badges and the lines under a title.
export const VOTEBOX_FONT_SIZE_CAPTION = "13px";
// Counters, compact options and text buttons.
export const VOTEBOX_FONT_SIZE_SMALL = "14px";
// Option texts, voter names and the validate button.
export const VOTEBOX_FONT_SIZE_BODY = "15px";
// 16px at least, so that iOS does not zoom on the focused field.
export const VOTEBOX_FONT_SIZE_INPUT = "16px";
export const VOTEBOX_FONT_WEIGHT_REGULAR = 400;
export const VOTEBOX_FONT_WEIGHT_MEDIUM = 500;
export const VOTEBOX_FONT_WEIGHT_SEMIBOLD = 600;
export const VOTEBOX_FONT_WEIGHT_BOLD = 700;
export const VOTEBOX_LINE_HEIGHT = 1.4;
// Icons of the text buttons (sort, proxies) and of "show all options".
export const VOTEBOX_SMALL_ICON_SIZE = "16px";
export const VOTEBOX_ICON_SIZE = "18px";
